import React, { useEffect, useRef, useState } from "react";
import { useLocation, Link, useNavigate } from "react-router-dom";
// import { useUser } from "../../context/UserContext";
import { FaChevronLeft } from "react-icons/fa6";
import { LuDot } from "react-icons/lu";

import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaStar } from "react-icons/fa";
// import { CiCamera } from "react-icons/ci";
// import { BsDot } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  postPhotoFetcher,
  postFetcher,
  getFetcher,
} from "../../../api/fetchers.ts";
import { endpoints } from "../../../api/endpoints.ts";
// import camIcon from "../../assets/images/camIcon.png";
import { IoMdPhotos } from "react-icons/io";
import { useUser } from "../../context/UserContext.tsx";
import { useLanguage } from "../../context/LanguageContext.tsx";
import { useCurrency } from "../../context/CurrencyContext.tsx";
import { calculateDiscountedPrice } from "../../utils/functions.tsx";

interface ProductRateFormValues {
  productRatings: { [key: string]: number };
  comments: { [key: string]: string };
  images: any;
}

interface Order {
  [x: string]: any;
  id: string;
  orderNumber: string;
  totalAmount: string;
  deliveryStatus: number;
  deliveryDate: string;
  createdAt: string;
  deliveryNumber: string;
  productInfo: {
    productId: string;
    productName: string;
    productPrice: number;
    quantity: number;
    images: string;
    code: string;
  };
  supplierInfo: {
    supplierId: string;
    supplierName: string;
    supplierSurName: string;
    supplierMarketPlaceName: string;
    supplierAdress: string;
    supplierBank: string;
    supplierIBAN: string;
  };
  customerName: string;
  customerPhone: string;
  deliveryAddress: string;
}

interface LocationState {
  groupOrders: Order[];
  date: string;
  totalPrice: any;
  orderCount: number;
  orderId: any;
}

const OrderDetail: React.FC = () => {
  const { exchangeRate, currencySymbol, currency } = useCurrency();
  const { t } = useLanguage();
  const location = useLocation();
  const navigate = useNavigate();
  const { groupOrders, date, totalPrice, orderCount, orderId } =
    (location.state as LocationState) || {};
  const [rateModal, setRateModal] = useState<boolean>(false);
  // const [isProduct, setIsProduct] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const [showRepeatModal, setShowRepeatModal] = useState<boolean>(false);
  const [basketIds, setBasketIds] = useState<any>([]);
  const { user } = useUser();
  const [userBusinessPackage, setUserBusinessPackage] = useState<any>();

  const modalRef = useRef<any>(null);
  const modalRef2 = useRef<any>(null);

  if (!groupOrders) {
    return <div>Sipariş bilgisi bulunamadı.</div>;
  }

  // const formatDateToTurkish = (dateString: any) => {
  //   try {
  //     // Tarih değeri kontrolü
  //     if (!dateString) {
  //       return "Tarih bilgisi yok";
  //     }

  //     // ISO string formatına dönüştür
  //     const date = new Date(dateString);

  //     // Geçerli tarih kontrolü
  //     if (isNaN(date.getTime())) {
  //       return "";
  //     }

  //     return new Intl.DateTimeFormat("tr-TR", {
  //       day: "2-digit",
  //       month: "long",
  //       year: "numeric",
  //     }).format(date);
  //   } catch (error) {
  //     console.error("Tarih formatlanırken hata oluştu:", error);
  //     return "Tarih formatlanamadı";
  //   }
  // };

  const formatDateToEnglish = (dateString: any) => {
    try {
      if (!dateString) {
        return "No date available";
      }

      const date = new Date(dateString);

      if (isNaN(date.getTime())) {
        return "";
      }

      return new Intl.DateTimeFormat("en-US", {
        day: "2-digit",
        month: "long",
        year: "numeric",
      }).format(date);
    } catch (error) {
      console.error("Error formatting date:", error);
      return "Date could not be formatted";
    }
  };

  const handleRate = (order: any) => {
    if (order.deliveryStatus === 1) {
      toast.warning(t("toastMessage", "rate1"));
    }
    if (order.deliveryStatus === 2) {
      toast.warning(t("toastMessage", "rate2"));
    }
    if (order.deliveryStatus === 3) {
      toast.warning(t("toastMessage", "rate3"));
    }
    if (order.deliveryStatus === 4) {
      // navigate("/profile/order-rate", {
      //   state: {
      //     groupOrders,
      //     previousPath: location.pathname,
      //     date,
      //     totalPrice,
      //     orderCount,
      //   },
      // });
      setRateModal(true);
      // setIsProduct(true);
      setSelectedProduct(order);
    }
    if (order.deliveryStatus === 5) {
      // navigate("/profile/order-rate", {
      //   state: {
      //     groupOrders,
      //     previousPath: location.pathname,
      //     date,
      //     totalPrice,
      //     orderCount,
      //   },
      // });
      setRateModal(true);
      // setIsProduct(true);
      setSelectedProduct(order);
    }
    if (order.deliveryStatus === 6) {
      // navigate("/profile/order-rate", {
      //   state: {
      //     groupOrders,
      //     previousPath: location.pathname,
      //     date,
      //     totalPrice,
      //     orderCount,
      //   },
      // });
      setRateModal(true);
      // setIsProduct(true);
      setSelectedProduct(order);
    }

    // navigate('/profile/order-rate', {
    //     state: {
    //         groupOrders,
    //         previousPath: location.pathname,
    //         isSellerTab: isSeller,
    //         date,
    //         totalPrice,
    //         orderCount
    //     }
    // });
  };

  const handleReturn = (order: Order) => {
    if (order.deliveryStatus === 1) {
      toast.warning(t("toastMessage", "rate4"));
    }
    if (order.deliveryStatus === 2) {
      toast.warning(t("toastMessage", "rate5"));
    }
    if (order.deliveryStatus === 3) {
      toast.warning(t("toastMessage", "rate6"));
    }
    if (order.deliveryStatus === 4) {
      navigate("/profile/product-return", {
        state: {
          order,
          previousPath: location.pathname,
          date,
          totalPrice,
          orderCount,
        },
      });
    }
    if (order.deliveryStatus === 5) {
      toast.warning(t("toastMessage", "rate7"));
    }
    if (order.deliveryStatus === 6) {
      toast.warning(t("toastMessage", "rate8"));
    }
  };

  const fetchBusinessPackageData = async () => {
    if (user) {
      try {
        const businessPackage = await getFetcher(
          endpoints.user.getBusinessPackageById.replace(
            "{id}",
            user.businessPackageId
          )
        );
        if (businessPackage.result) {
          setUserBusinessPackage(businessPackage.businessPackage);
        }
      } catch (error) {
        console.error("Error fetching favorites:", error);
      }
    }
  };

  useEffect(() => {
    fetchBusinessPackageData();
  }, []);

  // const handleProforma = () => {
  //   setSelectedOrder(groupOrders[0]);
  //   setShowProformaModal(true);
  // };

  // ORDER STATUS
  // const orderStatusFunc = (status: number) => {
  //   switch (status) {
  //     case 1:
  //       return "Sipariş Hazırlanıyor";
  //     case 2:
  //       return "Reddedildi";
  //     case 3:
  //       return "Kargoda";
  //     case 4:
  //       return "Teslim Edildi";
  //     case 5:
  //       return "İptal Edildi";
  //     case 6:
  //       return "İade Edildi";
  //     default:
  //       return "Bilinmeyen Durum";
  //   }
  // };

  const handleClickOutside = (event: any) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setRateModal(false);
    }
    if (modalRef2.current && !modalRef2.current.contains(event.target)) {
      setShowRepeatModal(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // const handleClickProductRate = (product: any) => {
  //   setRateModal(true);
  //   setIsProduct(true);
  //   setSelectedProduct(product);
  // };

  const productValidationSchema = Yup.object().shape({
    productRatings: Yup.object().test(
      "productRatings",
      "All products must be rated",
      (obj: Record<string, number>) => {
        return Object.values(obj).every((rating) => rating > 0);
      }
    ),
    comments: Yup.object().test(
      "comments",
      "All products must have a comment",
      (obj: Record<string, string>) => {
        return Object.values(obj).every(
          (comment) => typeof comment === "string" && comment.trim() !== ""
        );
      }
    ),
  });

  const initialValues: ProductRateFormValues = {
    productRatings: {},
    comments: {},
    images: groupOrders.reduce(
      (acc, order) => ({
        ...acc,
        [order.id]: { image1: "", image2: "", image3: "" },
      }),
      {}
    ),
  };

  {
    /* IMAGE UPLOAD FUNCTION */
  }
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>,
    orderId: string,
    imageIndex: number,
    setFieldValue: (field: string, value: any) => void
  ) => {
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      if (fileExtension === "svg") {
        toast.error(t("toastMessage", "rate9"));
        return;
      }
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await postPhotoFetcher(
          endpoints.updateImage.updateImageSingle,
          formData
        );
        if (response && response.data && response.data.url) {
          setFieldValue(
            `images.${orderId}.image${imageIndex + 1}`,
            response.data.url
          );
          toast.success(t("toastMessage", "rate10"));
        } else {
          toast.error(t("toastMessage", "rate11"));
        }
      } catch (error) {
        toast.error(t("toastMessage", "rate11"));
        console.error("Error uploading photo:", error);
      }
    }
  };

  const handleRepeat = () => {
    setShowRepeatModal(true);
  };

  useEffect(() => {
    const ids = groupOrders?.map((item: any) => item?.basketId);
    setBasketIds(ids);
  }, []);

  const handleConfirm = async () => {
    try {
      if (groupOrders) {
        const response = await postFetcher(endpoints.orders.createOrder, {
          arg: {
            id: user?.id,
            basketIds: basketIds,
            customerName: groupOrders[0].customerName,
            customerPhone: groupOrders[0].customerPhone,
            customerEmail: groupOrders[0].customerEmail,
            city: groupOrders[0].city,
            district: groupOrders[0].district,
            couponCode: groupOrders[0].couponCode,
            totalAmount: Number(groupOrders[0].totalAmount),
            deliveryAddress: groupOrders[0].deliveryAddress,
            currency: currency,
          },
        });
        if (response.result) {
          if (user) {
            toast.success(t("toastMessage", "order1"), {
              hideProgressBar: true,
            });

            setTimeout(() => {
              window.location.href = response?.paymentLink;
            }, 2000);
          } else {
            toast.success(t("toastMessage", "order2"));
            setTimeout(() => {
              window.location.href = response?.paymentLink;
            }, 2000);
          }
        } else {
          if ((response.message = "All fields required")) {
            toast.error(t("toastMessage", "order3"));
          }
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
      />

      <div className="p-4 md:px-6 md:py-4  rounded-lg h-full overflow-y-auto bg-[#FBFBFB]">
        <div className=" flex items-center">
          <Link
            to="/profile/orders"
            className=" text-[#191C1F] px-4 py-2 rounded-md"
          >
            <FaChevronLeft size={25} className=" font-bold " />
          </Link>

          <h2 className="text-primary-color text-3xl font-semibold ">
            {t("orderDetail", "title")}
          </h2>
        </div>

        <div className="border border-[#DCDCDC] mt-3 rounded-t-lg ">
          <div className=" h-[150px] lg:h-[130px] bg-primary-color rounded-t-lg p-8 text-white flex flex-col lg:flex-row items-center">
            <div className=" flex flex-col gap-y-2 flex-1">
              <span className=" text-[14px] md:text-[20px] font-normal font-poppins">
                #{orderId}
              </span>
              <div className=" flex items-center text-[10px] md:text-[14px] gap-x-1 min-w-[250px] md:min-w-[350px]">
                <span className=" ">
                  {groupOrders?.length} {t("orderDetail", "product")}{" "}
                </span>
                <LuDot />
                <span>
                  {t("orderDetail", "date")} {formatDateToEnglish(date)}
                </span>
              </div>
            </div>

            <div className=" text-[#FFC633]  text-[35px] md:text-[42px] flex-1 flex flex-col items-end xl:items-center ">
              {currencySymbol}
              {totalPrice}
              <p className=" text-xs font-semibold">
                ({t("orderDetail", "discount")})
              </p>
            </div>
          </div>

          <div className="  mt-4 px-6">
            <div className=" flex w-[97%] mx-auto items-center gap-x-1 my-4">
              <h2 className=" font-[500] font-poppins text-[#191C1F]">
                {t("orderDetail", "product")}
              </h2>
              <span className=" font-normal text-[13px]">
                ({groupOrders?.length})
              </span>
            </div>

            <div>
              <div className="overflow-x-auto ">
                <table className="table-auto w-full rounded-lg ">
                  <thead className="bg-[#F2F4F5] border-[2px] border-[#E4E7E9] mb-4">
                    <tr>
                      <th className=" px-4 py-2 text-left font-semibold text-gray-700">
                        {t("orderDetail", "productName")}
                      </th>
                      <th className=" px-4 py-2 text-left font-semibold text-gray-700">
                        {t("orderDetail", "price")}
                      </th>
                      <th className=" px-4 py-2 text-left font-semibold text-gray-700">
                        {t("orderDetail", "quantity")}
                      </th>
                      <th className=" px-4 py-2 text-left font-semibold text-gray-700">
                        {t("orderDetail", "total")}
                      </th>
                      <th className=" px-4 py-2 text-left font-semibold text-gray-700"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {groupOrders?.map((item: any, i: number) => {
                      return (
                        <tr key={i} className="py-4 border-b border-[#E4E7E9]">
                          {/* img & name */}
                          <td className="px-4 py-2 text-gray-800">
                            <div className="flex items-center gap-x-3">
                              <img
                                className="w-16 h-16 sm:w-24 sm:h-24 object-contain rounded-md"
                                src={item?.productInfo?.images[0]}
                                alt="Ürün"
                              />
                              <p className="text-[#141C3A] font-semibold text-sm sm:text-[13px] truncate max-w-[150px] sm:max-w-none">
                                {item?.productInfo?.productName}
                              </p>
                            </div>
                          </td>
                          {/* price */}
                          <td className="px-4 py-2 text-gray-800">
                            <span className="text-[#475156] text-sm sm:text-[16px] font-normal">
                              {calculateDiscountedPrice(
                                item?.productInfo?.price,
                                item?.productInfo?.discount,
                                userBusinessPackage
                                  ? userBusinessPackage?.ratio
                                  : 0,
                                exchangeRate
                              )?.toFixed(2)}
                              {currencySymbol}
                            </span>
                          </td>
                          {/* quantity */}
                          <td className="px-4 py-2 text-gray-800">
                            <span className="text-[#475156] text-sm sm:text-[16px] font-normal">
                              x {item?.productInfo?.quantity}
                            </span>
                          </td>
                          {/* total */}
                          <td className="px-4 py-2 text-gray-800">
                            <span className=" text-sm sm:text-[16px] font-[500]  mr-2">
                              {(
                                calculateDiscountedPrice(
                                  item?.productInfo?.price,
                                  item?.productInfo?.discount,
                                  userBusinessPackage
                                    ? userBusinessPackage?.ratio
                                    : 0,
                                  exchangeRate
                                ) * item?.productInfo?.quantity
                              )?.toFixed(2)}
                              {currencySymbol}
                            </span>
                          </td>
                          {/* actions */}
                          <td className="px-4 py-2 text-gray-800">
                            <button
                              onClick={() => handleRate(item)}
                              className=" bg-[#8792BB] text-yellow-color font-poppins font-extrabold py-1 px-2 rounded-lg text-[12px] active:scale-90 transition-transform"
                            >
                              {t("orderDetail", "rateButton")}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* addresses */}
          <div className=" h-full xl:h-[300px] w-[98%] mb-2 flex flex-col xl:flex-row mx-auto justify-between bg-white mt-8 border border[#E4E7E9] text-[#191C1F] font-poppins font-[500] ">
            {/* Billing Address */}
            <div className="flex-1 border-b xl:border-b-0 border-r-0 xl:border-r border-[#E4E7E9] flex flex-col gap-y-5 items-center lg:items-start m-0 mt-4 lg:m-8">
              {/* Başlık */}
              <div>
                <h2 className="text-[16px] sm:text-[18px] lg:text-[21px] text-center lg:text-left font-semibold">
                  {t("orderDetail", "invoiceAddress")}
                </h2>
              </div>

              {/* İçerik */}
              <div className="text-[12px] sm:text-[14px] lg:text-[16px] flex flex-col gap-y-3 rounded-lg">
                {/* İsim */}
                <p className="font-semibold text-[#141C3A] text-center lg:text-left">
                  {groupOrders[0]?.customerName}
                </p>

                {/* Adres */}
                <p className="text-[#5F6C72] font-normal break-words text-center lg:text-left">
                  {groupOrders[0]?.deliveryAddress
                    ?.split(",")
                    ?.slice(2)
                    ?.join(",")
                    ?.trim()}
                </p>

                {/* Telefon */}
                <div className="flex flex-col sm:flex-row sm:gap-x-1 items-center lg:items-start gap-y-1">
                  <p className="font-medium text-[#141C3A]">
                    {t("orderDetail", "phone")}:
                  </p>
                  <span className="text-[#5F6C72]">
                    {groupOrders[0]?.customerPhone}
                  </span>
                </div>

                {/* Email */}
                <div className="flex flex-col sm:flex-row sm:gap-x-1 items-center lg:items-start gap-y-1">
                  <p className="font-medium text-[#141C3A]">Email:</p>
                  <span className="text-[#5F6C72] break-words">
                    {groupOrders[0]?.customerEmail}
                  </span>
                </div>
              </div>
            </div>

            {/* Shipping Address */}
            <div className="flex-1 border-b xl:border-b-0 border-r-0 xl:border-r border-[#E4E7E9] flex flex-col gap-y-5 items-center lg:items-start m-0 mt-4 lg:m-8">
              {/* Başlık */}
              <div>
                <h2 className="text-[16px] sm:text-[18px] lg:text-[21px] text-center lg:text-left font-semibold">
                  {t("orderDetail", "deliveryAddress")}
                </h2>
              </div>

              {/* İçerik */}
              <div className="text-[12px] sm:text-[14px] lg:text-[16px] flex flex-col gap-y-3 rounded-lg">
                {/* İsim */}
                <p className="font-semibold text-[#141C3A] text-center lg:text-left">
                  {groupOrders[0]?.customerName}
                </p>

                {/* Adres */}
                <p className="text-[#5F6C72] font-normal break-words text-center lg:text-left">
                  {groupOrders[0]?.deliveryAddress
                    ?.split(",")
                    ?.slice(2)
                    ?.join(",")
                    ?.trim()}
                </p>

                {/* Telefon */}
                <div className="flex flex-col sm:flex-row sm:gap-x-1 items-center lg:items-start gap-y-1">
                  <p className="font-medium text-[#141C3A]">
                    {t("orderDetail", "phone")}:
                  </p>
                  <span className="text-[#5F6C72]">
                    {groupOrders[0]?.customerPhone}
                  </span>
                </div>

                {/* Email */}
                <div className="flex flex-col sm:flex-row sm:gap-x-1 items-center lg:items-start gap-y-1">
                  <p className="font-medium text-[#141C3A]">Email:</p>
                  <span className="text-[#5F6C72] break-words">
                    {groupOrders[0]?.customerEmail}
                  </span>
                </div>
              </div>
            </div>

            {/* Order Notes */}
            <div className="flex-1 m-8 flex flex-col gap-y-5 items-center lg:items-start">
              <div className=" font-poppins font-extrabold flex flex-col gap-y-5 justify-center items-center w-full h-full text-[14px]">
                <div>
                  <button
                    onClick={() => handleRepeat()}
                    className=" bg-primary-color text-yellow-color p-3 rounded-xl active:scale-90 transition-transform min-w-[220px]"
                  >
                    {t("orderDetail", "repeatButton")}
                  </button>
                </div>

                <div>
                  <button
                    onClick={() => handleReturn(groupOrders[0])}
                    className=" bg-yellow-color  p-3 rounded-xl active:scale-90 transition-transform min-w-[220px] text-primary-color"
                  >
                    {t("orderDetail", "refundButton")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {rateModal && selectedProduct && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 p-4 sm:p-6">
          <div
            ref={modalRef}
            className="w-full max-w-md sm:max-w-lg lg:max-w-xl bg-white rounded-lg shadow-lg p-6 md:p-12"
          >
            <h2 className="text-xl sm:text-2xl font-semibold font-poppins text-[14px] mb-4  text-start border-b py-2 text-[#191C1F] -mt-8">
              {t("orderDetail", "rateButton")}
            </h2>

            <Formik
              initialValues={initialValues}
              validationSchema={productValidationSchema}
              onSubmit={async (values, { resetForm }) => {
                const productData = {
                  productId: selectedProduct?.productInfo?.productId,
                  supplierId: selectedProduct?.supplierInfo?.supplierId,
                  rating: values?.productRatings[selectedProduct?.id],
                  review: values?.comments[selectedProduct?.id],
                  images: values?.images[selectedProduct?.id],
                };

                try {
                  const response = await postFetcher(
                    endpoints.products.postProductEvaluation,
                    {
                      arg: {
                        productId: productData?.productId,
                        supplierId: productData?.supplierId,
                        rating: productData?.rating,
                        review: productData?.review,
                        images: productData?.images,
                      },
                    }
                  );
                  if (response.result) {
                    toast.success(
                      `${selectedProduct?.productInfo?.productName} ${t(
                        "orderDetail",
                        "rate13"
                      )}`
                    );
                    setRateModal(false);
                  } else {
                    let errorMessage =
                      response?.message ||
                      "Değerlendirme sırasında bir hata oluştu.";

                    if (
                      errorMessage === "Please provide all required fields."
                    ) {
                      errorMessage = "Lütfen tüm gerekli alanları doldurun.";
                      return toast.error(`${errorMessage}`);
                    } else if (
                      errorMessage === "Product evaluation already exists."
                    ) {
                      errorMessage = "Bu ürünü zaten değerlendirdiniz.";
                    }
                    setRateModal(false);
                    return toast.error(
                      `${selectedProduct?.productInfo?.productName} için ${errorMessage}`
                    );
                  }
                } catch (error: any) {
                  const errorMessage =
                    error.response?.data?.message ||
                    "Değerlendirme sırasında bir hata oluştu.";
                  toast.error(
                    `${selectedProduct?.productInfo?.productName} için ${errorMessage}`
                  );
                  console.error("Error submitting evaluation:", error);
                }

                resetForm();
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <div key={selectedProduct.id} className="mb-6 flex flex-col">
                    {/* PRODUCT IMAGE AND DETAILS */}
                    <div className="mb-6 flex items-center">
                      <img
                        src={selectedProduct?.productInfo?.images[0]}
                        alt={selectedProduct?.productInfo?.productName}
                        className="w-14 h-auto object-cover mb-4 sm:mb-0 sm:mr-4"
                      />
                      <div>
                        <h3 className="font-bold text-lg sm:text-xl text-primary-color py-2">
                          {selectedProduct?.productInfo?.productName}
                        </h3>
                        <p className="text-xs sm:text-sm text-gray-500 mt-2 flex gap-x-1">
                          <p>{t("orderDetail", "p1")}</p>{" "}
                          <span className="font-semibold">
                            {
                              selectedProduct?.supplierInfo
                                ?.supplierMarketPlaceName
                            }
                          </span>{" "}
                          <p>{t("orderDetail", "p2")}</p>
                        </p>
                      </div>
                    </div>
                    {/* PRODUCT RATINGS */}
                    <div className="mb-6">
                      <h4 className="font-semibold text-sm sm:text-base">
                        {t("orderDetail", "score")}
                      </h4>
                      <div className="flex gap-4 mt-2">
                        {[...Array(5)].map((_, index) => (
                          <FaStar
                            key={index}
                            className={`cursor-pointer text-2xl ${
                              index <
                              (values?.productRatings[selectedProduct?.id] || 0)
                                ? "text-yellow-color"
                                : "text-gray-300"
                            }`}
                            onClick={() =>
                              setFieldValue(
                                `productRatings.${selectedProduct?.id}`,
                                index + 1
                              )
                            }
                          />
                        ))}
                      </div>
                      <ErrorMessage
                        name={`productRatings.${selectedProduct?.id}`}
                        component="div"
                        className="text-red-500 text-xs mt-2"
                      />
                    </div>
                    {/* ADD IMAGE */}
                    <div className="mb-6">
                      <h4 className="font-semibold mb-2 text-sm sm:text-base">
                        {t("orderDetail", "photo")}
                      </h4>
                      <div className="flex flex-wrap gap-4">
                        {[0, 1, 2].map((index) => (
                          <label
                            key={index}
                            className="w-20 h-20 sm:w-28 sm:h-28 border-2 border-dashed border-gray-300 flex flex-col items-center justify-center cursor-pointer"
                          >
                            <input
                              type="file"
                              className="hidden"
                              accept="image/*"
                              onChange={(event) =>
                                handleImageUpload(
                                  event,
                                  selectedProduct?.id,
                                  index,
                                  setFieldValue
                                )
                              }
                            />
                            {values?.images[selectedProduct?.id]?.[
                              `image${index + 1}`
                            ] ? (
                              <img
                                src={
                                  values.images[selectedProduct?.id][
                                    `image${index + 1}`
                                  ]
                                }
                                alt={`Preview ${index + 1}`}
                                className="w-full h-full object-cover"
                              />
                            ) : (
                              <IoMdPhotos size={35} />
                            )}
                          </label>
                        ))}
                      </div>
                    </div>
                    {/* COMMENTS */}
                    <div className="mb-6">
                      <h4 className="font-semibold mb-2 text-sm sm:text-base">
                        {t("orderDetail", "commentary")}
                      </h4>
                      <Field
                        as="textarea"
                        className="w-full p-2 shadow shadow-gray-400 rounded"
                        rows={4}
                        name={`comments.${selectedProduct?.id}`}
                        placeholder={t("orderDetail", "cP")}
                      />
                      <ErrorMessage
                        name={`comments.${selectedProduct?.id}`}
                        component="div"
                        className="text-red-500 text-xs mt-2"
                      />
                    </div>
                  </div>
                  <div className="flex justify-center w-full ">
                    <button
                      type="submit"
                      className="bg-yellow-color text-white px-6 py-2 w-full rounded text-sm sm:text-base disabled:opacity-50 disabled:cursor-not-allowed font-poppins font-semibold"
                      disabled={groupOrders.some(
                        () =>
                          !values?.productRatings[selectedProduct?.id] ||
                          !values?.comments[selectedProduct?.id]?.trim()
                      )}
                    >
                      {t("orderDetail", "evaluateButton")}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      )}

      {showRepeatModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 p-4 sm:p-6">
          <div
            ref={modalRef2}
            className="w-full max-w-md sm:max-w-lg lg:max-w-xl bg-white rounded-lg shadow-lg p-6 md:p-12"
          >
            <h2 className="text-xl sm:text-2xl font-semibold font-poppins text-[14px] mb-4  text-start border-b py-2 text-[#191C1F] -mt-8">
              {t("orderDetail", "repeatButton")}
            </h2>

            <div>
              <table className="table-auto w-full rounded-lg">
                <tbody>
                  {groupOrders?.map((item: any, i: number) => {
                    return (
                      <tr key={i} className="py-4 border-b border-[#E4E7E9]">
                        {/* img & name */}
                        <td className="px-4 py-2 text-gray-800">
                          <div className="flex items-center gap-x-3">
                            <img
                              className="w-12 h-12 sm:w-16 sm:h-16 object-contain rounded-md"
                              src={item?.productInfo.images[0]}
                              alt="Ürün"
                            />
                            <p className="text-[#141C3A] font-semibold text-sm sm:text-[12px] truncate max-w-[120px] ">
                              {item?.productInfo?.productName}
                            </p>
                          </div>
                        </td>
                        {/* price */}
                        <td className="px-4 py-2 text-gray-800">
                          <span className="text-[#475156] text-sm sm:text-[14px] font-normal">
                            {calculateDiscountedPrice(
                              item?.productInfo?.price,
                              item?.productInfo?.discount,
                              userBusinessPackage
                                ? userBusinessPackage?.ratio
                                : 0,
                              exchangeRate
                            ).toFixed(2)}
                            {currencySymbol}
                          </span>
                        </td>
                        {/* quantity */}
                        <td className="px-4 py-2 text-gray-800">
                          <span className="text-[#475156] text-sm sm:text-[14px] font-normal">
                            x {item?.productInfo?.quantity}
                          </span>
                        </td>
                        {/* total */}
                        <td className="px-4 py-2 text-gray-800">
                          <span className="text-[#475156] text-sm sm:text-[14px] font-[500]">
                            {calculateDiscountedPrice(
                              item?.productInfo?.price,
                              item?.productInfo?.discount,
                              userBusinessPackage
                                ? userBusinessPackage?.ratio
                                : 0,
                              exchangeRate
                            ).toFixed(2)}
                            {currencySymbol}
                          </span>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="mt-4 flex justify-start font-poppins items-center font-semibold gap-x-3">
              <p className=" font-[500] ">{t("orderDetail", "total")}:</p>
              <span>
                {totalPrice}
                {currencySymbol}
              </span>
              <p className=" text-[10px] mt-[2px] font-bold text-primary-color">
                ({t("orderDetail", "discount")})
              </p>
            </div>

            <div className="mt-4 flex justify-center items-center gap-x-5">
              <button
                onClick={() => setShowRepeatModal(false)}
                className=" bg-yellow-color text-primary-color font-extrabold py-2 rounded-lg w-[95%] active:scale-90 transition-transform text-[13px]"
              >
                {t("orderDetail", "giveButton")}
              </button>
              <button
                onClick={handleConfirm}
                className=" bg-primary-color text-yellow-color font-extrabold py-2 rounded-lg w-[95%] active:scale-90 transition-transform text-[13px]"
              >
                {t("orderDetail", "approveButton")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderDetail;
